module.exports = __webpack_public_path__ + "img/logo1.38d2f21e.png";